module.exports = __webpack_public_path__ + "static/media/left-menu-screens.1efb4aa1.svg";